import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { mutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { z } from 'zod';

export const SetOrderPaidSchema = z.object({
  transfer_proof: z.instanceof(File, {
    message: 'Bukti transfer harus berupa file!',
  }),
});
export type SetOrderPaidData = z.infer<typeof SetOrderPaidSchema>;
export type SetOrderPaidPayload = {
  order_id: string;
  data: SetOrderPaidData;
};
export type SetOrderPaidResponse = ApiResponse<null>;

export function toSetOrderPaidFormData(data: SetOrderPaidData): FormData {
  const formData = new FormData();
  formData.append('transfer_proof', data.transfer_proof);
  return formData;
}

export const setOrderPaid = async (
  payload: SetOrderPaidPayload
): Promise<SetOrderPaidResponse> => {
  const { order_id, data } = payload;
  const url = `order/${order_id}/paid`;
  const formData = toSetOrderPaidFormData(data);

  return await apiClient.patch(url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export function setOrderPaidMutationOptions() {
  return mutationOptions<SetOrderPaidResponse, AxiosError, SetOrderPaidPayload>(
    {
      mutationFn: setOrderPaid,
    }
  );
}
